<template>
  <q-panel class="clearfix header-panel">
    <div
      :style="getMenuButtonsStyle"
    >
      <q-divider direction="vertical" />
      <router-link :to="{ name: 'home' }">
        <q-link
          :underline="false"
          class="q-link"
        >
          <span>{{ this.$qt('home.header.atrvasa') }}</span>
        </q-link>
      </router-link>
      <q-divider direction="vertical" />
      <q-dropdown
        @command="handleCommand"
      >
        <span class="q-dropdown-link">
          {{ this.$qt('home.header.selectLanguage') }}
          <i :class="'q-icon-arrow-down q-icon--' + isRtl ? 'left' : 'right'" />
        </span>
        <q-dropdown-menu slot="dropdown">
          <q-dropdown-item
            v-for="l in languageList"
            :key="l.cultureName"
            :command="l.cultureName"
          >
            <span>{{ l.name }}</span>
          </q-dropdown-item>
        </q-dropdown-menu>
      </q-dropdown>
      <q-divider direction="vertical" />
      <router-link to="/logout">
        <q-link
          :underline="false"
          class="q-link"
        >
          <span>{{ this.$qt('dashboard.logoutTitle') }}</span>
        </q-link>
      </router-link>
      <q-divider direction="vertical" />
    </div>
    <div
      :style="getSocialButtonsStyle"
    >
      <q-divider direction="vertical" />
      <q-link
        :underline="false"
        class="q-link"
        target="_blank"
        href="https://twitter.com/atrvasa"
      >
        <font-awesome-icon :icon="['fab', 'twitter']" />
      </q-link>
      <q-divider direction="vertical" />
      <q-link
        :underline="false"
        class="q-link"
        target="_blank"
        href="https://github.com/atrvasa"
      >
        <font-awesome-icon :icon="['fab', 'github']" />
      </q-link>
      <q-divider direction="vertical" />
      <q-link
        :underline="false"
        class="q-link"
        target="_blank"
        href="https://www.linkedin.com/in/atrvasa/"
      >
        <font-awesome-icon :icon="['fab', 'linkedin']" />
      </q-link>
      <q-divider direction="vertical" />
      <q-link
        :underline="false"
        class="q-link"
        target="_blank"
        href="https://www.youtube.com/channel/UCOk87zodKiOT7Fgdn1RjGMQ"
      >
        <font-awesome-icon :icon="['fab', 'youtube']" />
      </q-link>
      <q-divider direction="vertical" />
    </div>
  </q-panel>
</template>

<script>


  export default {
    name: "QDashboardHeader",

    data() {
      return {
        languageList: [],
        language: this.$store.state.session.cultureName
      }
    },

    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      getSocialButtonsStyle() {
        let isRtl = this.$qt('direction') === 'rtl';

        const ret = {};

        if (isRtl) {
          ret.direction = 'ltr';
          ret.float = 'left';
        } else {
          ret.direction = 'rtl';
          ret.float = 'right';
        }

        return ret;
      },
      getMenuButtonsStyle() {
        let isRtl = this.$qt('direction') === 'rtl';

        const ret = {};

        if (isRtl) {
          // ret.direction = 'ltr';
          ret.float = 'right';
        } else {
          // ret.direction = 'rtl';
          ret.float = 'left';
        }

        return ret;
      }
    },

    mounted() {
      this.$delegate('gausaka', 'getLanguages', {}).then((response) => {
        this.languageList = response.result.models;
      })
    },

    methods: {
      handleCommand(command) {
        this.$delegate('gausaka', 'changeSessionLanguage', {
          cultureName: command
        }).then((response) => {
          this.$store.commit('changeLanguage', command);
          this.$message(response.message);
        })
      }
    },
  }
</script>

<style scoped>
    .header-panel {
        margin: 0 5px 10px 5px;
        padding: 10px;
        line-height: 40px;
    }

    a, .q-link {
        text-decoration: none;
        color: #0000009e;
    }
</style>